import './_credits.scss';
import {useContext, useEffect, useRef, useState} from "react";
import {CardList} from "../cardList";

export default function Credits({variant}) {
    const [isShown, setIsShown] = useState(true);
    const cardList = useContext(CardList);
    const [pdfUrl, setPdfUrl] = useState(null);

    const [shareableObject, setShareableObject] = useState(null);

    function isMobile() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Check for common mobile device identifiers
        return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    }

    function isIos() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Check for common mobile device identifiers
        return /iphone|ipad|ipod|Macintosh|AppleWebKit/i.test(userAgent);
    }

    useEffect( () => {
        setPdfUrl(`./assets/img/postcards/${cardList[variant -1 ]?.pdf}`);
        createShareableObject(variant);
        requestAnimationFrame(() => {
            setIsShown(!!variant)
        })
    }, [variant])

    function createShareableObject(variant) {
        if (!variant) return;
        let url = 'https://opusb.pl/swieta24/assets/img/postcards/' + cardList[variant -1 ]?.image;
        try {
            fetch(url).then(resp => {
                resp.blob().then( blob => {
                    const file = new File([blob], 'wesolych-swiat.png', { type: blob.type });
                    const objectToShare = {
                        title: "Wesołych świąt",
                        files: [file],
                    };
                    if (navigator.canShare(objectToShare)) {
                        setShareableObject(objectToShare);
                    }
                })
            })
        }
        catch (e) {
            console.log('Cant fetch image for variant '+ variant);
        }
    }

    function share() {
        if (shareableObject) {
            navigator.share(shareableObject)
        }
    }

    return <div className={'credits ' + (!variant ? 'removed': '') + ' ' + (isShown ? 'visible': '')}>
           <p>
               {cardList[variant-1]?.sex === 'F' ? 'Tę grafikę przygotowała dla Ciebie nasza projektantka':'Tę grafikę przygotował dla Ciebie nasz projektant'} <br/>
               {cardList[variant-1]?.name}
           </p>
        { isMobile() && shareableObject ?
            (<a onClick={share} target='_blank' className='share'>
                {
                    isIos() ? <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8m-4-6l-4-4l-4 4m4-4v13"/></svg>
                    : <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12a3 3 0 1 0 6 0a3 3 0 1 0-6 0m12-6a3 3 0 1 0 6 0a3 3 0 1 0-6 0m0 12a3 3 0 1 0 6 0a3 3 0 1 0-6 0m-6.3-7.3l6.6-3.4m-6.6 6l6.6 3.4"/></svg>
                }
                Udostępnij kartkę
            </a>)
            :
            (<a href={pdfUrl} target='_blank'>Pobierz w formie kartki do druku</a>) }

        </div>
}
